import { Dispatch, SetStateAction, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { mockPrintFormsStore } from '@features/print-forms'
import { PrintFormConfig } from '@features/print-forms'

import { ROUTES } from '@constants'

type UseHandlersProps = {
  setConfigs: Dispatch<SetStateAction<PrintFormConfig[]>>
}

export const useHandlers = ({ setConfigs }: UseHandlersProps) => {
  const navigate = useNavigate()

  const [idToDelete, setIdToDelete] = useState<string | undefined>()
  const [copyId, setCopyId] = useState<string | undefined>()
  const [copyTitle, setCopyTitle] = useState<string>('')

  const refetch = () => setConfigs([...mockPrintFormsStore.getAll()])

  const handleCreate = () => navigate(ROUTES.PRINT_FORMS_CREATE)

  const handleEdit = (id: string) => navigate(ROUTES.PRINT_FORMS_EDIT + '/' + id)

  const handleShowDeleteModal = (id: string) => setIdToDelete(id)

  const handleCloseDeleteModal = () => setIdToDelete(undefined)

  const handleDelete = () => {
    if (idToDelete) {
      mockPrintFormsStore.delete(idToDelete)
      refetch()
      setIdToDelete(undefined)
    }
  }

  const handleShowCopyDialog = (id: string, title: string) => {
    setCopyId(id)
    setCopyTitle(title)
  }

  const handleCloseCopyDialog = () => {
    setCopyId(undefined)
    setCopyTitle('')
  }

  const handleCopy = (newId: string, newTitle: string) => {
    if (copyId) {
      mockPrintFormsStore.copy(copyId, newId, newTitle)
      refetch()
    }
    handleCloseCopyDialog()
  }

  return {
    state: {
      idToDelete,
      showCopyDialog: Boolean(copyId),
      copyId,
      copyTitle,
    },
    handlers: {
      handleCreate,
      handleEdit,
      handleShowDeleteModal,
      handleCloseDeleteModal,
      handleDelete,
      handleShowCopyDialog,
      handleCloseCopyDialog,
      handleCopy,
    },
  }
}
